const footerLinks = {
  CAPIFRANCE: [
    {
      name: 'Presse',
      id: 41,
    },
    {
      name: 'Médiathèque',
      id: 111,
    },
    {
      name: 'Signature mail',
      id: 65,
    },
  ],
};

export default footerLinks;
